import ReferencePicker from './reference-picker.vue'
export type { ReferencePickerProps } from './props'
export default ReferencePicker